import {Icon} from "./Icon";
import React from "react";

interface RequestPopupProps {
    open: boolean;
    onClose: () => void;
    onOK: () => void;
}

export const ChangeAddressPopup = (props: RequestPopupProps) => {
    if (!props.open) return <></>;
    return (
        <>
            <div className="z-50 fixed inset-0 bg-littleblack flex items-start md:items-center justify-center p-2">
                <div className="xl:w-3/12 md:w-3/5 w-full flex flex-col  bg-white p-6 space-y-4 overflow-y-auto">
                    <div className="flex flex-row justify-between pb-4">
                        <p className="text-12 font-medium">
                            배송정보를 변경할 경우 <br/>
                            상품 수거 및 수령 주소가 모두 변경됩니다.
                        </p>
                        <button
                            onClick={props.onClose}
                            className="flex wh-5 flex-row space-x-2 items-center"
                        >
                            <Icon.X/>
                        </button>
                    </div>
                    <button className={'button filled-gray-900 md:px-20 h-9'} onClick={props.onOK}>변경하기</button>
                    <button className={'button outlined-gray-900 md:px-20 h-9'} onClick={props.onClose}>취소</button>
                </div>
            </div>
        </>
    )
}
